import PageHomeMenu from "./PageHomeMenu";

function PageHome() {
  return (
    <div className="nc-PageHome relative">
      <PageHomeMenu />
    </div>
  );
}

export default PageHome;
